import { render, staticRenderFns } from "./ScientificResearch.vue?vue&type=template&id=3528ef0f&scoped=true&"
import script from "./ScientificResearch.vue?vue&type=script&lang=js&"
export * from "./ScientificResearch.vue?vue&type=script&lang=js&"
import style0 from "./ScientificResearch.vue?vue&type=style&index=0&id=3528ef0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528ef0f",
  null
  
)

export default component.exports